import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Moment from 'moment';
import "moment/locale/ko";
import LotSelectModal from "../common/LotSelectModal";
import QualitySelectModal from "../common/QualitySelectModal";

let newFileID = 1;
let realFiles = [];
function QualityMeasurementRegModal({ title, onClose, handleRegSuccessSave, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [fileRows, setFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    quality_measurement_id: null,
    quality_measurement_group_id: null,
    quality_measurement_parent_id: null,
    quality_id: '',
    quality_name: '',
    quality_item_id: '',
    quality_item_name: '',
    quality_item_spec: '',
    quality_measurement_item_id: '',
    quality_measurement_standard: '',
    quality_measurement_status: '',
    quality_measurement_number: '',
    quality_measurement_lotno: '',
    quality_measurement_value: '',
    quality_measurement_option_value: '',
    quality_measurement_option_name: '',
    quality_measurement_option_name_value: '',
    quality_measurement_result: '',
    quality_measurement_result_name: '',
    quality_measurement_user_id: '',
    quality_measurement_user_name: '',
    quality_measurement_datetime: '',
    quality_measurement_produce_work_id:null,
    quality_measurement_produce_work_number:'',
    quality_measurement_incoming_id:null,
    quality_measurement_incoming_number:'',
    quality_measurement_outgoing_id:null,
    quality_measurement_outgoing_number:'',
    quality_measurement_bigo: ''
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectQualityModalOpen, setSelectQualityModalOpen] = useState(false);
  const [isSelectLotModalOpen, setSelectLotModalOpen] = useState(false);
  const [passData, setPassData] = useState({
    quality_pass_start_number: '',
    quality_pass_start_standard: '',
    quality_pass_end_number: '',
    quality_pass_end_standard: ''
  });
  const [optionModalOption, setOptionModalOption] = useState([]);
  const [optionNameModalOption, setOptionNameModalOption] = useState([]);
  const [optionPassModalOption, setOptionPassModalOption] = useState([]);

  const handleSetting = () => {
    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: true,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: true,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    let ADD_YN= 'Y'
    var array = [];
    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){
        array.push({
          id: newFileID,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_name: tmp_file_name,
          file_type_name: tmp_file_type_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_reg_user_name,
          reg_datetime: tmp_reg_datetime,
          row_type:tmp_row_type,
          update_type: tmp_update_type
        })
        newFileID = newFileID + 1;
      }
    }
    setUpdateFileRows(array);
    
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(appStore.getMaxListID(fileRows))+1,
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);
  
  const onClick = (e)=>{ 

    if(e.target.name === 'quality_measurement_lotno'){
      setSelectModalTitle('Lot 목록')
      setSelectLotModalOpen(true);
    }else if(e.target.name === 'quality_name'){
      setSelectModalTitle('품질 목록')
      setSelectQualityModalOpen(true);
    }
    
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    let nextInputs = {
        ...inputs,
        [name]: value, 
    };

    if(name === 'quality_measurement_value'){
      var start_gijun = true;
      var end_gijun = true;
      if(passData.quality_pass_start_number !== '' && passData.quality_pass_start_standard !== ''){
        start_gijun = false;

        if(passData.quality_pass_start_standard === '1' && Number(passData.quality_pass_start_number) <= Number(value)
        || passData.quality_pass_start_standard === '2' && Number(passData.quality_pass_start_number) < Number(value)){
          start_gijun = true;
        }
      }
      
      if(passData.quality_pass_end_number !== '' && passData.quality_pass_end_standard !== ''){
        end_gijun = false;

        if(passData.quality_pass_end_standard === '3' && Number(passData.quality_pass_end_number) >= Number(value)
        || passData.quality_pass_end_standard === '4' && Number(passData.quality_pass_end_number) > Number(value)){
          end_gijun = true;
        }
      }

      if(value !== ''){
        if(start_gijun && end_gijun){
          nextInputs = {
            ...inputs,
            [name] : value,
            ['quality_measurement_result'] : 'Y',
            ['quality_measurement_result_name'] : "합격"
          };
        }else{
          nextInputs = {
            ...inputs,
            [name] : value,
            ['quality_measurement_result'] : 'N',
            ['quality_measurement_result_name'] : "불합격"
          };
        }
      }
    }

    setInputs(nextInputs);
  };

  const onSelectChange = (type, value) => {
    let nextInputs = {
        ...inputs,
        [type] : value
    };
    
    if(type === 'quality_measurement_option_name'){
      nextInputs = {
        ...inputs,
        [type] : value,
        ['quality_measurement_option_value'] : optionModalOption[value].label,
        ['quality_measurement_option_name_value'] : optionNameModalOption[value].label,
        ['quality_measurement_result'] : optionPassModalOption[value].label,
        ['quality_measurement_result_name'] : optionPassModalOption[value].label === 'Y'?"합격":"불합격",
      };
    }
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };
  
  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {

      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
      }
      
      var array = [];
      for(var i=0; i<realFiles.length; i++){
        var tmp_sever_file_name = realFiles[i].name;
        var tmp_file_name = realFiles[i].name;
        var tmp_file_size = realFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(realFiles[i].size);
        var tmp_file_type = realFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(realFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);

        array.push({
          id: newFileID,
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        })
        newFileID = newFileID + 1;
      }
      setFileRows(array);
    }
  };

  const fileDeleteClick = (object) => {
    //파일 삭제 버튼
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }
    setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //품질 파일 다운로드
  };

  const handleLotClick = (object) => {

    if(object.item_id !== '' && (inputs.quality_item_id !== '' && inputs.quality_item_id !== null && inputs.quality_item_id !== 0) && object.item_id !== inputs.quality_item_id){
      Swal.fire({
        title: '<p style="color:red">Lot 품목 오류</p>',
        html: '선택된 품질 품목정보와 Lot 품목정보가 동일해야 합니다. ',
        confirmButtonText: '확인'
      });
    }else{
      var nextInputs = {
        ...inputs,
        ['quality_measurement_item_id']: object.item_id,
        ['quality_measurement_lotno']: object.item_lotno,
        ['quality_measurement_incoming_id']: typeof object.item_lot_c_incoming_id === 'undefined'? "":object.item_lot_c_incoming_id,
        ['quality_measurement_outgoing_id']: typeof object.item_lot_d_outgoing_id === 'undefined'? "":object.item_lot_d_outgoing_id,
        ['quality_measurement_produce_work_id']: typeof object.item_lot_c_produce_work_id === 'undefined'? "":object.item_lot_c_produce_work_id,
      };
      setInputs(nextInputs);
    }
  };

  const handleQualityClick = (object) => {
    
    if(object.quality_item_id !== '' && (inputs.quality_measurement_item_id !== '' && inputs.quality_measurement_item_id !== null && inputs.quality_measurement_item_id !== 0) && object.quality_item_id !== inputs.quality_measurement_item_id){
      Swal.fire({
        title: '<p style="color:red">품질 품목 오류</p>',
        html: '선택된 Lot 품목정보와 품질 품목정보가 동일해야 합니다.',
        confirmButtonText: '확인'
      });
    }else{
      if(object.quality_measurement_standard === 'O'){
        var option_name = object.quality_option_name;
        var option_pass_yn = object.quality_option_pass_yn;
        var arr_option = option_name.split(",");
        var arr_option_name = option_name.split(",");
        var arr_option_pass_yn = option_pass_yn.split(",");
        
        var array_option = [];
        var array_option_name = [];
        var array_option_pass_yn = [];
        
        for(var i=0; i<arr_option.length; i++){
          if(String(arr_option[i]) !== ''){
            array_option.push({value:String(i), label: String((Number(i)+1))});
            array_option_name.push({value:String(i), label: String(arr_option_name[i])});
            array_option_pass_yn.push({value:String(i), label: String(arr_option_pass_yn[i])});
          }
        }
  
        setOptionModalOption(array_option);
        setOptionNameModalOption(array_option_name);
        setOptionPassModalOption(array_option_pass_yn);
      }else if(object.quality_measurement_standard === 'N'){
        setPassData({
          quality_pass_start_number: object.quality_pass_start_number,
          quality_pass_start_standard: object.quality_pass_start_standard,
          quality_pass_end_number: object.quality_pass_end_number,
          quality_pass_end_standard: object.quality_pass_end_standard
        })
      }
      var nextInputs = {
        ...inputs,
        ['quality_id']: object.id,
        ['quality_name']: object.quality_name,
        ['quality_item_id']: object.quality_item_id,
        ['quality_item_name']: object.quality_item_name,
        quality_item_spec: appStore.ITEM_FULL_SPEC_MAKE(
          object.quality_item_spec,
          object.quality_item_width,
          object.quality_item_depth,
          object.quality_item_height
        ),
        ['quality_measurement_standard']:object.quality_measurement_standard
      };
      setInputs(nextInputs);
    }
  };
  
  const handleSave = (event) => {
    let msg = '';
    if(inputs.quality_measurement_lotno === '' || inputs.quality_measurement_lotno === null){
      msg = '품질 LotNo는 필수 입력 입니다.';
    }else if(inputs.quality_id === '' || inputs.quality_id === null){
      msg = '품질정보는 필수 입력 입니다.';
    }else if(inputs.quality_measurement_standard === 'N' && (inputs.quality_measurement_value === '' || inputs.quality_measurement_value === null)){
      msg = '품질측정값은 필수 입력 입니다.';
    }else if(inputs.quality_measurement_standard === 'O' && (inputs.quality_measurement_option_name === '' || inputs.quality_measurement_option_name === null)){
      msg = '품질옵션은 필수 입력 입니다.';
    }
    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">품질 측정 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/QualityMeasurement/Reg", {inputs} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          var selectID = response.data;
          if(updateFileRows.length > 0) {

            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'QualityMeasurement');
            formData.append('type', 'Reg');
            formData.append('updateFileRows', JSON.stringify(updateFileRows));
            
            for(var i=0; i<realFiles.length; i++){            
              formData.append('files', realFiles[i]);
            }
            
            axios.post('/api/SaveCommon/GridFileSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            }).then(response => {
              handleRegSuccessSave(selectID);
            }).catch(error => {
              appStore.capture();
            });

          }else{

            handleRegSuccessSave(selectID);

          }

        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .finally(() => {
          appStore.setLoading(false); 
      });

    }
  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="품질 측정 정보" value="1" />
                <Tab label="품질 측정 파일" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">품질측정번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="품질측정번호" value={inputs.quality_measurement_number} name="quality_measurement_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">품질 LotNo<span className="essential">*</span></div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '350px' } }>
                          <input type="text" placeholder="품질 LotNo" value={inputs.quality_measurement_lotno} name="quality_measurement_lotno" autoComplete="off" style={ { backgroundColor: '#EFEFEF4D', float: 'left', width: '150px', marginRight: '12px', cursor: 'pointer' } } onClick={(e) => onClick(e) } readOnly />
                          {/*
                          {
                            (inputs.quality_measurement_produce_work_id === '' || inputs.quality_measurement_produce_work_id !== 0 && inputs.quality_measurement_produce_work_id !== null)?
                            <><input type="text" placeholder="생산번호" value={inputs.quality_measurement_produce_work_number} name="quality_measurement_produce_work_number" autoComplete="off" style={ { backgroundColor: '#EFEFEF4D', float: 'left', width: '120px' } } readOnly /></>:<></>
                          }
                          {
                            (inputs.quality_measurement_incoming_id === '' || inputs.quality_measurement_incoming_id !== 0 && inputs.quality_measurement_incoming_id !== null)?
                            <><input type="text" placeholder="입고번호" value={inputs.quality_measurement_incoming_number} name="quality_measurement_incoming_number" autoComplete="off" style={ { backgroundColor: '#EFEFEF4D', float: 'left', width: '120px' } } readOnly /></>:<></>
                          }
                          {
                            (inputs.quality_measurement_outgoing_id === '' || inputs.quality_measurement_outgoing_id !== 0 && inputs.quality_measurement_outgoing_id !== null)?
                            <><input type="text" placeholder="출하번호" value={inputs.quality_measurement_outgoing_number} name="quality_measurement_outgoing_number" autoComplete="off" style={ { backgroundColor: '#EFEFEF4D', float: 'left', width: '120px' } } readOnly /></>:<></>
                          }
                          */}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">품질정보<span className="essential">*</span></div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '200px', marginRight: '10px' } }>
                          <input type="text" placeholder="품질" value={inputs.quality_name} name="quality_name" autoComplete="off" style={ { cursor: 'pointer', backgroundColor: '#EFEFEF4D' } } onClick={(e) => onClick(e) } readOnly />
                        </div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '557px' } }>
                          <input type="text" placeholder="품목" value={inputs.quality_item_name} name="quality_item_name" onChange={(e) => onChange(e) } style={{ float: 'left', width: '260px', backgroundColor: '#EFEFEF4D', marginRight: '10px' }} readOnly />
                          <input type="text" placeholder="규격" value={inputs.quality_item_spec} name="quality_item_spec" onChange={(e) => onChange(e) } style={{ float: 'left', width: '470px', backgroundColor: '#EFEFEF4D' }} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">품질측정<span className="essential">*</span></div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '200px', marginRight: '10px' } }>
                          {inputs.quality_measurement_standard === 'N'?
                          <input type="number" placeholder="측정값" value={inputs.quality_measurement_value} name="quality_measurement_value" onChange={(e) => onChange(e) } autoComplete="off"  />
                          :
                          <Select className="modal_filed_input_select" placeholder="옵션" value={optionNameModalOption.filter(function (option) { return option.value === inputs.quality_measurement_option_name;  })} onChange={(e) => onSelectChange('quality_measurement_option_name',e.value)} options={optionNameModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                          }
                        </div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '557px' } }>
                          <input type="text" placeholder="측정결과" value={inputs.quality_measurement_result_name} name="quality_measurement_result_name" onChange={(e) => onChange(e) } style={{ float: 'left', width: '150px', backgroundColor: '#EFEFEF4D', marginRight: '10px' }} readOnly />
                          <input type="text" placeholder="측정자" value={inputs.quality_measurement_user_name} name="quality_measurement_user_name" onChange={(e) => onChange(e) } style={{ float: 'left', width: '150px', backgroundColor: '#EFEFEF4D', marginRight: '10px' }} readOnly />
                          <input type="text" placeholder="측정일시" value={inputs.quality_measurement_datetime} name="quality_measurement_datetime" onChange={(e) => onChange(e) } style={{ float: 'left', width: '198px', backgroundColor: '#EFEFEF4D' }} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="비고" value={inputs.quality_measurement_bigo} name="quality_measurement_bigo" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {MenuUpdateYN === 'Y' &&
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                      </Button> }
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectLotModalOpen && (<LotSelectModal
          onClose={() => {
              setSelectLotModalOpen(false);
          }}
          title={selectmodalTitle}
          handleLotClick={handleLotClick}
          status={'CD'}
          />)}
        {isSelectQualityModalOpen && (<QualitySelectModal
          onClose={() => {
              setSelectQualityModalOpen(false);
          }}
          title={selectmodalTitle}
          handleQualityClick={handleQualityClick}
          />)}
    </PCModal>
  );
}

export default QualityMeasurementRegModal;